module.exports = __webpack_public_path__ + "img/pagoefectivo.3483f53.png";